
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M9 11.605V15.5M6.11 2.591l.002-.091h5.703v.091c0 1.047-.308 1.997-.81 2.694V7.49C12.008 8.322 13 9.753 13 11.38v.12H5.001v-.12c0-1.627 1.003-3.058 2.006-3.89V5.402c-.553-.706-.897-1.704-.897-2.81"}})])
          )
        }
      }
    